import { render, staticRenderFns } from "./JdpStageView.vue?vue&type=template&id=2fe8a0c7&"
import script from "./JdpStageView.vue?vue&type=script&lang=ts&"
export * from "./JdpStageView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports